<template>
	<section class="content checkout-content max-w-1120 wp_AllPageMarginTop"
										style="min-height: 90vh">
		<!-- visible each block after pressing continue -->
		<!--<loading-->
		<!--:active.sync="showLoader"-->
		<!--:can-cancel="false"-->
		<!--:is-full-page="false"-->
		<!--:opacity="1"-->
		<!--loader="dots"-->
		<!--&gt;</loading>-->
		<!--<login-banner>-->

		<!--</login-banner>-->
		<page-loader v-if="showCheckoutLoader">
		</page-loader>
		<!-- Custom -->
		<div class="container" v-else>
			<div class="row m-0 mb-3">
				<div class="col-lg-8">
					<delivery-address @toOrderSummary="step = 2"/>
					<order-summary :step="step" @toPayment="step = 3"/>
					<payment-options :step="step" @payment="step = 2"/>
				</div>
				<div class="col-lg-4 wp_paddingTopContainer">
					<div class="wp_ContainerCartSummery">
						<div class="wp_CartSummerySideBarConatiner dropshadow">
							<cart-summary
								:cartCount="getBuyNowProductCount"
								:cartTotal="getBuyNowTotal"
								:cartItemsTotal="getBuyNowItemTotal"
								:cartTotalOffer="getBuyNowOffer"
								v-if="getBuyNowProductCount > 0"
							/>
							<cart-summary
								:cartCount="getCartCount"
								:cartTotal="getcartTotal"
								:cartItemsTotal="getcartItemTotal"
								:cartTotalOffer="getcartTotalOffer"
								v-else
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- Custom -->
	</section>
</template>

<script>
// import Loading from 'vue-loading-overlay'
import DeliveryAddress from '@/components/pages/checkout/widgets/DeliveryAddress'
import OrderSummary from '@/components/pages/checkout/widgets/OrderSummary'
import PaymentOptions from '@/components/pages/checkout/widgets/PaymentOptions'
import CartSummary from '@/components/pages/cart/cartContainer/cartSummary/CartSummary'
import { store } from '@/store/store'
import { mapGetters } from 'vuex'
import { cartApis } from '@/services/ApiServices/cartApis'
import PageLoader from '../../shared/loader/pageLoader'

export default {
	data () {
		return {
			step: 1,
			showCheckoutLoader: true
		}
	},
	components: {
		PageLoader,
		DeliveryAddress,
		// LoginBanner,
		OrderSummary,
		CartSummary,
		PaymentOptions
		// Loading,
	},
	computed: {
		...mapGetters('cart', [
			'getCartProducts',
			'getCartCount',
			'getcartTotal',
			'getcartItemTotal',
			'getcartTotalOffer'
		]),
		...mapGetters('buynow', [
			'getBuyNowProduct',
			'getBuyNowProductCount',
			'getBuyNowTotal',
			'getBuyNowItemTotal',
			'getBuyNowOffer'
		]),

		...mapGetters('user', ['isAuthenticated'])
	},
	beforeCreate () {
		if ((this.getCartProducts && this.getCartProducts.length < 1) &&
				(this.getBuyNowProduct && this.getBuyNowProduct.length < 1)) {
			this.$router.push('/')
		} else {
			cartApis.insertCart().then(() => {
				cartApis.getCart().then(() => {
					this.showCheckoutLoader = false
					this.$nextTick(() => {
						$('#collapse-address').collapse('show')
					}, 1000)
				})
			})
			store.dispatch('user/setPromoCodeData', '')
			store.dispatch('cart/emptyCart')
			store.dispatch('user/clearGiftAmountData')
			store.dispatch('user/clearGiftCardNo')
			store.dispatch('user/clearGiftCardPin')
			store.dispatch('user/clearCoinRedeemData')
			store.dispatch('user/clearGiftData')
		}
	},
	mounted () {
		$('#collapse-address').collapse('show')
	},
	methods: {
		toOrderSummary (currentStep) {
			this.step = currentStep
		},
		toPayment (currentStep) {
			this.step = currentStep
		},
		payment (currentStep) {
			this.step = currentStep
		}
	},
	beforeRouteEnter (to, from, next) {
		if (store.getters['cart/getCartProducts'].length > 0) {
			next()
		} else if (store.getters['buynow/getBuyNowProduct'].length > 0 ||
				this.$route.query.buyNow === true) {
			next()
		} else {
			next('/cart')
		}
	}
}
</script>
